import React from 'react'
import { Map, List } from 'immutable'
import {
  CONTENT_IMAGE_TYPE_KEYART_WITH_TEXT,
  CONTENT_IMAGE_TYPE_KEYART_4K_WITH_TEXT,
} from '../../services/content/index'
import Picture, { IMAGE_TYPE_WEBP, IMAGE_LOADING_LAZY } from '../Picture/index'
import DetailPageV3JumbotronActions from './DetailPageV3JumbotronActions'
import { getOptimizedJumbotronImages } from './utils'

/**
 * @param {Object} props - The props
 * @param {Map} props.detailData - The detail data
 * @param {Object} props.ga4EventData - The GA4 event data
 * @returns {JSX.Element} DetailPageV3Jumbotron
 */
const DetailPageV3Jumbotron = (props) => {
  const {
    detailData = Map(),
    ga4EventData,
  } = props

  const standardImage = detailData.get('images', List()).find((i) => i.get('type') === CONTENT_IMAGE_TYPE_KEYART_WITH_TEXT)
  const image4k = detailData.get('images', List()).find((i) => i.get('type') === CONTENT_IMAGE_TYPE_KEYART_4K_WITH_TEXT)
  // provide image fallback logic
  const image = image4k || standardImage || Map()
  const imageUrls = getOptimizedJumbotronImages({ url: image.get('url') }) || {}
  const {
    fallbackImageUrl,
    smallImageUrl,
    mediumSmallImageUrl,
    mediumImageUrl,
    largeImageUrl,
    xLargeImageUrl,
  } = imageUrls

  return (
    <div className="detail-page-v3__jumbotron">
      <Picture
        fallbackSrc={fallbackImageUrl}
        width={'608'}
        height={'342'}
        alt=""
        imageClassName="detail-page-v3__jumbotron-image"
        loading={IMAGE_LOADING_LAZY}
        sources={[
          {
            type: IMAGE_TYPE_WEBP,
            srcSet: smallImageUrl,
            media: '(max-width: 480px)',
          },
          {
            type: IMAGE_TYPE_WEBP,
            srcSet: mediumSmallImageUrl,
            media: '(max-width: 608px)',
          },
          {
            type: IMAGE_TYPE_WEBP,
            srcSet: mediumImageUrl,
            media: '(max-width: 768px)',
          },
          {
            type: IMAGE_TYPE_WEBP,
            srcSet: largeImageUrl,
            media: '(max-width: 1199px)',
          },
          {
            type: IMAGE_TYPE_WEBP,
            srcSet: xLargeImageUrl,
            media: '(min-width: 1200px)',
          },
        ]}
      />
      <div className="detail-page-v3__jumbotron-content">
        <div className="detail-page-v3__layout-wrapper">
          <DetailPageV3JumbotronActions detailData={detailData} ga4EventData={ga4EventData} />
        </div>
      </div>
    </div>
  )
}

export default DetailPageV3Jumbotron
